module.exports = __webpack_public_path__ + "static/images/drop-off-before-route-optimize.3vLXzap.svg";